<template>
  <div class="m-0 dbozone-font bg" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="game-title" :class="`-${lang} `">{{ $t('govjoke.name') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.paytable') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} `">{{ $t('govjoke.paytable-des') }}</h5>
      </div>

      <div class="paytable-bg">
        <div class="grid-container">
          <div v-for="(symbol, index) in symbols" :key="index" class="grid-item">

            <img :src="symbol.image" class="symbol-image" alt="symbol" />
            <div class="payouts">
              <div v-for="(key) in Object.keys(symbol.payouts).map(Number).sort((a, b) => b - a)" :key="key"
                class="payout-row">
                <span class="sub-text-gray-payout" :style="getDynamicMargin(symbol.id)">{{ key
                }}&nbsp;&nbsp;-</span>
                <span class="sub-text-payout">{{ symbol.payouts[key] }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class=" align-items-center">
          <div class=" align-items-center justify-content-center d-flex">
            <img :src="require(`../../assets/resultGame/govjoke/sym_0.png`)" alt="symbol" class="symbol-image" />
          </div>
          <div style="margin-left: 4%;">
            <div class="payouts">
              <div v-for="(key) in Object.keys(symbols[10].payouts).map(Number).sort((a, b) => b - a)" :key="key"
                class="payout-row">
                <span class="sub-text-gray-payout" :style="getDynamicMargin(symbols[10].id)">{{ key
                  }}&nbsp;&nbsp;-</span>
                <span class="sub-text-payout">{{ symbols[10].payouts[key] }}</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.adjustment') }}</h5>
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 2" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`govjoke.adjustment-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.gamefeature') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.random-feature') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/govjoke/random_transform.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 1" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`govjoke.random-feature-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.transform-wild') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/govjoke/transform_wild.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 4" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`govjoke.transform-wild-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.wild') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/govjoke/wild_symbols.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 2" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`govjoke.wild-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.scatter') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/govjoke/scatter_symbols.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <span class="symbol-info">
          <p class="sub-text-list-gray pb-3">{{ $t(`govjoke.scatter-des1`) }}</p>
          <ul v-for="(li, index) in 4" :key="index">
            <li class="sub-text-list-gray">{{ $t(`govjoke.scatter-des${index + 2}`) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.freespin') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/govjoke/freespin_feature.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 3" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`govjoke.freespin-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.multipliers') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/govjoke/multiplier.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <ul class="symbol-info">
          <li v-for="index in 5" :key="`main-${index}`" class="sub-text-list-gray pt-2">
            {{ $t(`govjoke.multipliers-des${index}`) }}

            <ul v-if="index === 3" class="symbol-info">
              <li v-for="subIndex in 4" :key="`des3-${subIndex}`" class="pt-2">
                {{ $t(`govjoke.multipliers-des3-${subIndex}`) }}
              </li>
            </ul>

            <ul v-if="index === 4" class="symbol-info">
              <li v-for="subIndex in 1" :key="`des4-${subIndex}`" class="pt-2">
                {{ $t(`govjoke.multipliers-des4-${subIndex}`) }}
              </li>
            </ul>

            <ul v-if="index === 5" class="symbol-info">
              <li v-for="subIndex in 3" :key="`des5-${subIndex}`" class="pt-2">
                {{ $t(`govjoke.multipliers-des5-${subIndex}`) }}
                <ul v-if="subIndex === 2" class="symbol-info">
                  <li v-for="minorIndex in 5" :key="`des5-${minorIndex}`" class="pt-2">
                    {{ $t(`govjoke.multipliers-des5-2-${minorIndex}`) }}
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.featurebuy') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/govjoke/feature_buy_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span>
          <ul class="symbol-info">
            <li v-for="(li, index) in 7" :key="index" class="sub-text-list-gray pb-2">{{
              $t(`govjoke.featurebuy-des${index
                + 1}`)
                .replace('MIN', currencyFormatterWithSymbol(betMinMax[0]))
                .replace('MAX', currencyFormatterWithSymbol(featureBuyMaximum)) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span>
          <ul class="symbol-info">
            <li v-for="(li, index) in 3" :key="index" class="sub-text-list-gray pb-2">{{
              $t(`govjoke.featurebuy-des${index
                + 8}`)
                .replace('MIN', currencyFormatterWithSymbol(betMinMax[0]))
                .replace('MAX', currencyFormatterWithSymbol(featureBuyMaximum)) }}</li>
          </ul>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.rule') }}</h5>
      </div>

      <div class="volatility-wrapper">
        <img :src="require(`../../assets/ruleGames/volality/volatility_${imgLang}.png`)" class="volatility-image"
          alt="" />

        <div class="fire-container">
          <img v-for="(fire, index) in fires" :key="index" :src="getFireSrc(fire)" class="volatility-image-fire" />
        </div>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <h5 class="sub-text-gray text-des" :class="`-${lang} `">{{ $t('govjoke.text-rule1') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/govjoke/reel_area.png`)" alt="slotmachine"
          class="slotmachine-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <div v-for="(li, index) in 10" :key="index" class="sub-text-gray pb-2" :class="`-${lang} `">
            <li v-if="index + 1 != 5">
              {{ $t(`govjoke.game-rule${index + 1}`)
                .replace('MIN', currencyFormatterWithSymbol(betMinMax[0]))
                .replace('MAX', currencyFormatterWithSymbol(betMinMax[1]))
                .replace('CUR', formattedCurrency) }}
            </li>
            <li v-else-if="index + 1 == 5 && isShowCurrencySymbol">
              {{ $t(`govjoke.game-rule${index + 1}`)
                .replace('MIN', currencyFormatterWithSymbol(betMinMax[0]))
                .replace('MAX', currencyFormatterWithSymbol(betMinMax[1]))
                .replace('CUR', formattedCurrency) }}
            </li>
          </div>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-2 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('govjoke.round') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-start align-items-start">
        <div>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -govjoke`">
            {{ $t('govjoke.round-des') }}
          </h5>

          <ul class="pl-3">
            <li v-for="index in 5" :key="`round-${index}`" class="sub-text-gray text-des pb-2"
              :class="`-${lang} -govjoke`">
              {{ $t(`govjoke.round-des${index}`) }}

              <ul v-if="index === 5" class="pl-3">
                <li v-for="subIndex in 4" :key="`round5-${subIndex}`" class="pb-2" :class="`-${lang} -govjoke`">
                  {{ $t(`govjoke.round-des5-${subIndex}`) }}
                </li>
              </ul>
            </li>

            <li class="sub-text-gray text-des" :class="`-${lang} -govjoke`">
              {{ $t('govjoke.round-des6') }}
            </li>
          </ul>
        </div>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('main-game.title') }}</h5>
      </div>

      <table class="control-table">
        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/spin_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.spin-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">
              {{ $t(`main-game.spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/autospin_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.auto_spin-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/stop_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-round-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/betsize_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-option-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.bet-option-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/turbo_on.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.turbo-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.turbo-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/info_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.gamerule-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.gamerule-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/additional_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.additional-menu') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.additional-menu-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/setting_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.settings') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.settings-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/history_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.history-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.history-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/home_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.back') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.back-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/icon_wallet.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.wallet-balance-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{
              $t(`main-game.wallet-balance-button-des${index + 1}`) }} </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/icon_refresh.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.refresh-balance-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.refresh-balance-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/icon_bet.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-amount-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">{{
              $t(`main-game.bet-amount-button-des${index + 1}`) }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/govjoke/icon_win.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.winnings-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{ $t(`main-game.winnings-button-des${index
              + 1}`) }}</li>
          </td>
        </tr>
      </table>

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <u>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des1') }}
          </li>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des2') }}
          </li>
        </u>
      </div>

      <div class="p-3"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'rule',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    featureBuyMaximum: Number,
    featureBuyMultiplier: Number,
    currency: String,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable,
      symbols: this.generateSymbols(),
      fires: [true, true, true, false, false],
    }
  },
  mounted() {
    this.generateSymbols();
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    }
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      const cur = this.isShowCurrencySymbol === false ? '' : this.currency;
      return this.$options.filters.currencyFormatterWithSymbol(val, cur);
    },
    decimalFormat(value) {
      value = Math.round((value + Number.EPSILON) * 1000) / 1000;
      return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 3 });
    },
    generateSymbols() {
      const symbolsData = [];
      for (let i = 0; i < 9; i++) {

        let symbol = {
          id: i,
          image: require(`../../assets/ruleGames/govjoke/sym_${i}.png`),
          pays: [
            this.decimalFormat(this.data.config.payTable[i][4]),
            this.decimalFormat(this.data.config.payTable[i][3]),
            this.decimalFormat(this.data.config.payTable[i][2])
          ],
          payouts: {
            5: this.decimalFormat(this.currentBet * this.data.config.payTable[i][4] / this.baseBet),
            4: this.decimalFormat(this.currentBet * this.data.config.payTable[i][3] / this.baseBet),
            3: this.decimalFormat(this.currentBet * this.data.config.payTable[i][2] / this.baseBet),
          }
        }
        symbolsData.push(symbol);
      }
      symbolsData.sort((a, b) => b.id - a.id);
      this.symbols = symbolsData;
      return this.symbols;
    },
    getDynamicMargin(id) {
      const maxLength = this.decimalFormat(this.data.config.payTable[id][5]).length;
      let magin = 'calc(29%)'

      if (maxLength < 5) {
        magin = 'calc(26%)'
      } else if (maxLength === 5) {
        magin = 'calc(20%)'
      } else if (maxLength > 5 && maxLength < 7) {
        magin = 'calc(16%)'
      } else if (maxLength >= 7 && maxLength < 9) {
        magin = 'calc(13%)'
      } else if (maxLength >= 9 && maxLength < 11) {
        magin = 'calc(47%)'
      } else {
        magin = 'calc(4%)'
      }

      return {
        marginLeft: magin,
      };
    },
    getFireSrc(fire) {
      return require(
        fire
          ? `../../assets/ruleGames/volality/fire_appear.png`
          : `../../assets/ruleGames/volality/fire_disappear.png`
      );
    }
  }
}
</script>

<style scoped>
.paytable-bg {
  background-color: #202020;
  border-radius: 20px;
  padding: 20px;
  margin: 20px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  background-color: #202020;
  border-radius: 20px;
}

.grid-item {
  text-align: center;
  padding-top: 10%;
}

.symbol-image {
  width: clamp(195px, 15vw, 284px);
  margin-right: 30px;
  max-width: 284px;
  min-width: 117px;
  object-fit: contain;
}

.payouts {
  margin-top: 10px;
  margin-left: 18%;
}

.payout-row {
  display: flex;
  justify-content: left;
  align-items: left;
}

.symbol-container {
  margin: 5%;
  padding: 5%;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
}

.symbol-content {
  display: flex;
  align-items: center;
}

.special-symbol-image {
  width: 25%;
  margin-right: 20px;
  max-width: 119px;
}

.symbol-info {
  padding-left: 40px;
}

.symbol-info li {
  font-size: 3vw;
}

h2 {
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}

.wild-comming-image {
  width: 70%;
  height: auto;
}

.multiplier-image {
  width: 95%;
  height: auto;
}

.freespin-feature-image {
  width: 60%;
  height: auto;
}

.feature-buy-image {
  width: 40%;
  height: auto;
}

.win-line-image {
  width: 70%;
  height: auto;
}

.win-line-container {
  padding: 20px;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
  max-width: 600px;
  margin: auto;
  font-family: 'Arial', sans-serif;
}

h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.win-line-images {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}

.image-container {
  position: relative;
}

.check {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: green;
}

.cross {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: red;
}

.win-description,
.example,
.extra-info {
  margin: 10px 0;
  font-size: 14px;
}

.payout-table {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.payout-info ul {
  list-style: none;
  padding: 0;
}

.total-win {
  text-align: center;
}

.example-win {
  font-size: 3vw;
  color: #f39c12;
}

.extra-info {
  font-size: 12px;
  margin-top: 20px;
}

.slotmachine-image {
  width: 100%;
  height: auto;
}
</style>

<style>
.bg {
  background: #282828;
}

.game-title {
  font-size: 6vw;
  color: white;
}

.text-title {
  color: #fff;
  font-size: 4vw;
  text-align: center;
}

.sub-text-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
}

.sub-text-gray-payout {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin-left: calc(30%);
}

.sub-text-payout {
  color: #fff;
  font-size: 3vw;
  margin-left: 5%;
  text-align: left;
}

.sub-text-list-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin: 0 auto;
}

.sub-text {
  color: #fff;
  font-size: 3vw;
}

.sub-bg {
  background: #202020;
  border-radius: 30px;
}

.control-table {
  width: 100%;
  border-collapse: collapse;
}

.control-table td {
  border: 3px solid #fff;
  padding: 30px;
  vertical-align: middle;
}

.control-table h3 {
  margin-bottom: 30px;
  font-size: 3vw;
  color: #fff;
}

.control-table p {
  margin: 5px 0 0 0;
  font-size: 3vw;
}

.control-icon {
  width: clamp(78px, 10vw, 150px);
  height: auto;
}

.adjustment-text {
  padding-left: 20%;
  padding-right: 20%;
}

.text-des {
  line-height: 1.5;
}

@media (max-width: 480px) {
  .symbol-image {
    width: clamp(130px, 10vw, 189px);
    margin-right: 20px;
    max-width: 189px;
    min-width: 78px;
  }
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 900px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}

.volatility-wrapper {
  position: relative;

  width: 100%;
  max-width: 600px;

  margin: 0 auto;

  display: flex;
  justify-content: center;
}

.volatility-image {
  width: 70%;
  height: auto;
  display: block;
}

.fire-container {
  position: absolute;

  top: 22%;
  right: 22%;

  display: flex;
  align-items: center;

  gap: clamp(2px, 1vw, 6px);

  pointer-events: none;
}

.volatility-image-fire {
  width: clamp(18px, 4vw, 28px);
  height: auto;

  object-fit: contain;
}
</style>